import { FC } from 'react';

import type { TabType } from '../types/types';

import NotificationButton from '../buttons/notificationButton';
import LogoutButton from '../buttons/logoutButton';
import InviteButton from '../buttons/inviteButton';

interface IDefault {
  setActiveTab: (tab: TabType) => void;
}

const DefaultTab: FC<IDefault> = ({ setActiveTab }) => {
  return (
    <>
      <div className="pb-2 border-b border-gray-200">
        <NotificationButton setActiveTab={setActiveTab} />
        {/*<button className="flex items-center w-full p-2 rounded-md hover:bg-gray-100 cursor-pointer">
        <Cog6ToothIcon className="size-5 text-gray-600 mr-3" />
        Præferencer
      </button>*/}
        <LogoutButton />
      </div>
      <InviteButton />
    </>
  );
};

export default DefaultTab;
